import { render, staticRenderFns } from "./PaymentButton.vue?vue&type=template&id=566071ed&scoped=true"
var script = {}
import style0 from "./PaymentButton.vue?vue&type=style&index=0&id=566071ed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "566071ed",
  null
  
)

export default component.exports